import React from "react";
import CompareOriginalVsCompressed from "components/features/CompressorCommon/CompareOriginalVsCompressed";
import { WeSupportBulkImageCompressionSection } from "components/features/CompressorCommon/WeSupportBulkImageCompressionSection";
import BestUsageForGifCompressorSection from "components/features/GifCompressor/BestUsageForGifCompressorSection";
import GifCompressorFaq from "components/features/GifCompressor/GifCompressorFaq";

const GifCompressorPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <CompareOriginalVsCompressed
                    originalSizeInKb={1024}
                    compressedSizeInKb={485}
                    imageSrc1="/images/original_vs_compressed_animated.webp"
                    imageSrc2="/images/original_vs_compressed_animated.webp"
                />
                <WeSupportBulkImageCompressionSection image="/images/we_support_bulk_gif_compression_preview.webp" />
                <BestUsageForGifCompressorSection />
                <GifCompressorFaq />
            </div>
        </div>
    );
};

export default GifCompressorPreToolsArea;
